<a (click)="showInfo()" style="padding: 15px 0px;">
  <span>{{title}}</span>
</a>